/**
 * 用户模块
 */
import { request } from '@/apis/http';
import queryString from 'query-string';
import {
  CanteenDataPermissionReq,
  DataPermissionReq,
  DoLoginReq,
  OauthDemandGroupVo,
  SysUserAddReq,
  SysUserInfoALlUpdateReq,
  SysUserInfoVo,
  SysUserUpdateReq,
  UpdatePassWordReq,
  UserCanteenPermissionVo,
} from 'typings/openapi';
import {
  GetLoginInfoResponse,
  PostDoLoginRequest,
  PostDoLoginResponse,
  QuerySysRoleResponse,
  QueryUserRequest,
} from './types';

/**
 * 登录
 */
export const PostDoLogin = (data: PostDoLoginRequest) => {
  const target = queryString.parseUrl(location.href).query.target as string | undefined;
  const prefix = target ? target : location.host.split('.')?.[0];
  let loginReq: DoLoginReq = {
    platformType: data.platformType as DoLoginReq.platformType,
    accountId: data.accountId,
    password: data.password,
    loginType: data.status,
    identifier: prefix,
    identifierType: '1',
    ...data,
  };
  return request<PostDoLoginResponse>('/user/doLogin/pc', { method: 'POST', data: loginReq });
};

/**
 * 免密登录(AIO)
 */
export const PostAioSecretFreeLogin = (tenantId: string) => {
  return request<PostDoLoginResponse>(`/tenant/login/${tenantId}`, { method: 'POST' });
};

/**
 * 获取登录用户的信息
 */
export const GetLoginInfo = () => {
  return request<GetLoginInfoResponse>('/user/getUserInfo');
};

/**
 * 获取用户列表 | 查询用户基本信息
 */
export const QueryUsers = (data: QueryUserRequest) => {
  return request<PagingResponse<SysUserInfoVo>>('/user/queryList', { params: data });
};

/**
 * 新增用户
 * @param {string} id 用户id
 * @param {SysUserAddReq} data 用户信息
 *  */
export const CreateUser = (data: SysUserAddReq) => {
  return request('/user/add', { method: 'POST', data });
};

/**
 * 修改用户
 * @param {string} id 用户id
 * @param {SysUserAddReq} data 用户信息
 *  */
export const UpdateUser = (id: string, data: SysUserAddReq) => {
  return request(`/user/update/${id}`, { method: 'POST', data });
};

/**
 * 批量修改用户， 启动删除等
 */
export const BatchUpdateUser = (data: SysUserUpdateReq) => {
  return request('/user/batchUpdateUser', {
    method: 'POST',
    data: data,
  });
};

/**
 * 全量修改用户， 启动删除等
 */
export const AllUpdateUser = (data: SysUserInfoALlUpdateReq) => {
  return request('/user/allUpdate', {
    method: 'POST',
    data: data,
  });
};

/** 获取当前登录人角色列表 */
export const QuerySysRole = () => {
  return request<QuerySysRoleResponse[]>('/user/querySysRole', {
    method: 'GET',
  });
};

/** 用户修改密码 */
export const UpdateUserPassword = (data: UpdatePassWordReq) => {
  return request('/user/updatePsw', {
    method: 'POST',
    data: data,
  });
};

/** 设置数据权限 */
export const UpdateDataPermission = (data: DataPermissionReq) => {
  return request('/user/setDataPermission', {
    method: 'POST',
    data: data,
  });
};
/** 获取用户数据权限 */
export const GetDataPermission = (id: number) => {
  return request<OauthDemandGroupVo[]>(`/user/getDataPermission/${id}`, {
    method: 'GET',
  });
};

/** 设置食堂/档口数据权限 -- 需方 */
export const UpdatePurchaseDataPermission = (data: CanteenDataPermissionReq) => {
  return request('/user/setUserCanteenPermission', {
    method: 'POST',
    data: data,
  });
};
/** 获取用户食堂/档口权限 -- 需方 */
export const GetPurchaseDataPermission = (id: number) => {
  return request<UserCanteenPermissionVo>(`/user/getUserCanteenPermission/${id}`, {
    method: 'GET',
  });
};

/** 根据当前登陆token获取登陆用户的授权食堂和档口 */
export const GetUserCanteenPermission = () => {
  return request<UserCanteenPermissionVo>('/user/getUserCanteenPermission', {
    method: 'GET',
  });
};
